import { useQuery } from "@apollo/client";
import { ClientAddressesDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import type { ClientAddresses } from "@/types/profile";
import { useMemo } from "react";

export const useClientAddressesQuery = () => {
  const clientId = useAuthState((state) => state.data.userInfo.id);

  const result = useQuery(ClientAddressesDocument, {
    skip: !clientId,
    fetchPolicy: "cache-first",
    variables: {
      filters: {
        clientId,
      },
    },
  });

  const sortedAddresses = useMemo(() => {
    if (!result.data?.clientAddresses.addresses) return undefined;

    // Sort addresses with primary addresses first
    return [...result.data.clientAddresses.addresses].sort((a, b) => {
      return Number(b.primary) - Number(a.primary);
    }) as ClientAddresses[];
  }, [result.data?.clientAddresses.addresses]);

  return {
    ...result,
    data: sortedAddresses,
  };
};
